module.exports = "/assets/js/f89cfd6aedd3017e3528bdceb6885aec.svg";